import { render, staticRenderFns } from "./TrainingSessionAttendanceTableCpt.vue?vue&type=template&id=0b8609ee&scoped=true&"
import script from "./TrainingSessionAttendanceTableCpt.vue?vue&type=script&lang=ts&"
export * from "./TrainingSessionAttendanceTableCpt.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingSessionAttendanceTableCpt.vue?vue&type=style&index=0&id=0b8609ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8609ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VContainer,VSimpleTable})
